import { Injectable } from "@angular/core";
import { ComponentStore } from "@ngrx/component-store";
import { Observable } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import { DeletePromotionState } from "./delete-promotion.state";
import { PromotionService } from "src/app/services/promotion.service";

const initialState: DeletePromotionState = {
    loading: false,
    loaded: false,
    success: false,
    errorMessage: null,
};

@Injectable({
    providedIn: 'root'
})
export class DeletePromotionComponentStore extends ComponentStore<DeletePromotionState> {

    constructor(private readonly promotionService: PromotionService) {
        super(initialState);
    }

    readonly loading$: Observable<boolean> = this.select(state => state.loading);
    readonly loaded$: Observable<boolean> = this.select(state => state.loaded);
    readonly success$: Observable<boolean> = this.select(state => state.success);
    readonly errorMessage$: Observable<any> = this.select(state => state.errorMessage);

    readonly viewModel$ = this.select(
        this.loaded$,
        this.loading$,
        this.success$,
        this.errorMessage$,
        (loaded, loading, success, errorMessage) => ({
            loaded, loading, success, errorMessage
        })
    );

    readonly setInitial = this.updater(( _ : DeletePromotionState) => {
        return {
            ...initialState
        };
    });

    readonly setLoading = this.updater((state: DeletePromotionState) => {
        return {
            ...state,
            loading: true,
            loaded: false,
        };
    });

    readonly setLoaded = this.updater((state: DeletePromotionState) => {
        return {
            ...state,
            loading: false,
            loaded: true,
        };
    });

    readonly updateDetailState = this.updater((state: DeletePromotionState) => {
        return {
            ...state,
            loading: false,
            loaded: true,
            success: true,
        };
    });

    readonly setError = this.updater((state: DeletePromotionState, value: {
        errorMessage: string
    }) => {
        return {
            ...state,
            loading: false,
            loaded: true,
            success: false,
            errorMessage: value.errorMessage,
        };
    });

    readonly deleteCampaign = this.effect((detailParams$: Observable<{ companyId: string, promotionId: number }>) => {
        this.setLoading();
        return detailParams$.pipe(
            switchMap((params => this.promotionService.deletePromotion(params.companyId, params.promotionId).pipe(
                map(() => {
                    this.updateDetailState();
                    this.setLoaded();
                    this.setInitial();
                }
                ),
                catchError(async (error) => {
                    this.setError({ errorMessage: error });
                    this.setLoaded();
                    this.setInitial();
                })
            ))
            )
        );
    });
}